function cov_24uy8wxscp() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/See.tsx";
  var hash = "e36f765468638bb7c8488611cfc219cc9c032c9c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/See.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 43
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e36f765468638bb7c8488611cfc219cc9c032c9c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_24uy8wxscp = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_24uy8wxscp();
var Icon = (cov_24uy8wxscp().s[0]++, {
  name: 'see',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.5169 11.6375L15.8288 8.13438C13.7093 6.12115 10.3852 6.11772 8.26149 8.12657L4.55069 11.6367C4.34215 11.834 4.34215 12.1659 4.5507 12.3632L8.26188 15.8735C10.3856 17.8823 13.7098 17.8788 15.8293 15.8655L19.517 12.3626C19.7245 12.1654 19.7245 11.8346 19.5169 11.6375ZM17.5505 6.32174C14.4676 3.39341 9.63252 3.38841 6.54351 6.31038L2.83271 9.8205C1.58146 11.0041 1.58148 12.9958 2.83276 14.1794L6.54394 17.6897C9.63304 20.6117 14.4681 20.6065 17.551 17.6781L21.2387 14.1751C22.4839 12.9924 22.4839 11.0076 21.2387 9.82487L17.5505 6.32174Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.0001 13.5C12.8285 13.5 13.5001 12.8284 13.5001 12C13.5001 11.1716 12.8285 10.5 12.0001 10.5C11.1716 10.5 10.5001 11.1716 10.5001 12C10.5001 12.8284 11.1716 13.5 12.0001 13.5ZM12.0001 16C14.2092 16 16.0001 14.2091 16.0001 12C16.0001 9.79084 14.2092 7.99998 12.0001 7.99998C9.79091 7.99998 8.00005 9.79084 8.00005 12C8.00005 14.2091 9.79091 16 12.0001 16Z\" fill=\"currentColor\"/>"
});
export default Icon;